export const CART_ROUTE_NAMES = {
  CART: 'cart',
  CART_ORDER_REVIEW: 'cart-order-review',
};
